import { css } from "@emotion/react";
import styled from "@emotion/styled";

import type { WithStickyStackedHeightProps } from "scmp-app/lib/styles";

import { LiveArticleTimelineItem } from "./item";

export const Container = styled.div<WithStickyStackedHeightProps>`
  overscroll-behavior: contain;

  ${props => css`
    max-block-size: calc(100vh - ${props.$stickyStackedHeight + 43}px);
  `}
`;

export const StyledLiveArticleTimelineItem = styled(LiveArticleTimelineItem)``;
